import { render, staticRenderFns } from "./RemoveMicrolearningDialog.vue?vue&type=template&id=87710ba4"
import script from "./RemoveMicrolearningDialog.vue?vue&type=script&lang=js"
export * from "./RemoveMicrolearningDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports